import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
    HiOutlineUserCircle, HiOutlineShoppingBag, HiOutlineTruck, HiOutlineRefresh,
    HiOutlineShieldCheck, HiOutlineLockClosed, HiOutlineDocumentText
} from 'react-icons/hi';
import ProfileService from '../service/ProfileService';
import AuthenticationService from '../service/AuthenticationService';
import Skeleton from '../components/Skeleton'
import brand, { whatsappLink } from '../brand';
import '../css/declaration.css'

// One icon per brand.declaration section, in order.
const SECTION_ICONS = [HiOutlineUserCircle, HiOutlineShoppingBag, HiOutlineTruck, HiOutlineRefresh,
    HiOutlineShieldCheck, HiOutlineLockClosed, HiOutlineDocumentText]
const SUPPORT_WHATSAPP = whatsappLink()
const SAVE_ERROR = 'We could not save your acceptance. Please try again.'

class OnboardingForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userType: 0,
            errorMsg: '',
            isRedirectLoading: false,
            isSubmitting: false,
            accepted: false,
            hasShopRequest: false
        };
    }

    // Full load so Navbar picks up the new localStorage state. Admins and managers start at the Dashboard,
    // customers at the shop, so read the role first.
    goToStart = async () => {
        try {
            const res = await AuthenticationService.getUser()
            if (res && res.data) {
                AuthenticationService.updateAuthData(res.data.userName, res.data.isAdmin, res.data.hasProfile,
                    res.data.userType, res.data.role, res.data.canManageSettings)
            }
        } catch (error) {
            console.log(error)
        }
        window.location.replace(AuthenticationService.getIsAdmin() === "true" ? "/dashboard" : "/")
    }

    onToggleAccepted = (event) => {
        this.setState({ accepted: event.target.checked, errorMsg: '' })
    }

    onClickSubmit = async (event) => {
        event.preventDefault();
        const { accepted, isSubmitting, userType } = this.state
        if (!accepted || isSubmitting) return

        this.setState({ isSubmitting: true, errorMsg: '' })
        try {
            const res = await ProfileService.updateUserTypeDb(userType)
            if (res && res.status === 200) {
                ProfileService.updateUserType(userType)
                AuthenticationService.markProfileComplete();
                // Full load so Navbar picks up the new localStorage state.
                this.goToStart()
                return
            }
            this.setState({ isSubmitting: false, errorMsg: SAVE_ERROR })
        } catch (error) {
            if (error?.response?.status === 401) {
                this.props.history.push("/login")
                return
            }
            this.setState({ isSubmitting: false, errorMsg: SAVE_ERROR })
        }
    }


    async componentDidMount() {
        this.setState({
            isRedirectLoading: true
        })
        try {
            const res = await ProfileService.getUserPreference()
            // axiosInstance resolves with undefined after redirecting on 403.
            if (!res) return
            if (res.status === 200 && res.data && res.data.data) {
                const shopaccess = res.data.data.allowShop
                const isShop = res.data.data.isShop
                if (!isShop || (isShop && shopaccess)) {
                    ProfileService.updateUserType(this.state.userType)
                    AuthenticationService.markProfileComplete();
                    AuthenticationService.removePreferenceCount()
                    // Full load so Navbar picks up the new localStorage state; keep the skeleton until then.
                    this.goToStart()
                    return
                }
                this.setState({ hasShopRequest: isShop })
            } else {
                AuthenticationService.savePreferenceInCount()
            }
        } catch (error) {
            AuthenticationService.savePreferenceInCount()
            if (error?.response?.status === 401) {
                this.props.history.push("/login")
                return
            }
            console.log(error)
        }
        this.setState({
            isRedirectLoading: false
        })
    }

    render() {
        const { accepted, isSubmitting, isRedirectLoading, errorMsg } = this.state

        if (isRedirectLoading) {
            return (
                <main className='mv-page mv-declaration' aria-busy='true'>
                    <Skeleton width='260px' height={32} />
                    <Skeleton height={420} radius='14px' style={{ marginTop: 20 }} />
                </main>
            )
        }

        return (
            <main className='mv-page mv-declaration'>
                <header className='mv-page-head'>
                    <div>
                        <h1 className='mv-list-title'>{brand.declaration.title}</h1>
                        <p className='mv-page-sub'>{brand.declaration.intro}</p>
                    </div>
                </header>

                <form className='mv-card mv-declaration-card' onSubmit={this.onClickSubmit} noValidate>
                    <ol className='mv-declaration-list'>
                        {brand.declaration.sections.map((section, i) => {
                            const Icon = SECTION_ICONS[i] || HiOutlineDocumentText
                            return (
                                <li className='mv-declaration-section' key={section.title}>
                                    <span className='mv-declaration-icon' aria-hidden='true'><Icon /></span>
                                    <div>
                                        <h2 className='mv-declaration-heading'>{section.title}</h2>
                                        <ul className='mv-declaration-points'>
                                            {section.points.map(point => <li key={point}>{point}</li>)}
                                        </ul>
                                    </div>
                                </li>
                            )
                        })}
                    </ol>

                    <div className='mv-declaration-actions'>
                        {errorMsg && <div className='mv-alert mv-alert-error' role='alert'>{errorMsg}</div>}

                        <label className='mv-check'>
                            <input type='checkbox' checked={accepted} onChange={this.onToggleAccepted} disabled={isSubmitting} />
                            <span>I have read and agree to the {brand.declaration.title}.</span>
                        </label>

                        <button type='submit' className={`mv-btn mv-btn-primary mv-declaration-submit${isSubmitting ? ' is-busy' : ''}`}
                            disabled={!accepted || isSubmitting} aria-busy={isSubmitting}>
                            {isSubmitting ? 'Saving…' : 'Agree and continue'}
                        </button>
                    </div>
                </form>

                <p className='mv-declaration-help'>
                    Questions? <a href={SUPPORT_WHATSAPP} target='_blank' rel='noopener noreferrer'>Chat with us on WhatsApp</a>
                    <span aria-hidden='true'> · </span>
                    <Link to='/logout'>Log out</Link>
                </p>
            </main>
        );
    }
}

export default withRouter(OnboardingForm);
